import React, { useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import styles from './Login.module.css';
import '../styles/admin.css';

/**
 * Вход в админку.
 *
 * В прежней версии не было ни .catch, ни состояния отправки: при недоступном сервере
 * форма просто ничего не делала, а неверный пароль приходил со статусом 201.
 */
const Login = () => {
    const { isAuthenticated, login } = useAuth();
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [submitting, setSubmitting] = useState(false);

    if (isAuthenticated) {
        return <Redirect to="/admin" />;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSubmitting(true);

        try {
            await login(email.trim(), password);
            // Редирект произойдёт сам: isAuthenticated станет true, и компонент
            // размонтируется. Снимать submitting здесь нельзя — React ругается
            // на обновление состояния размонтированного компонента.
        } catch (err) {
            setError(err.message || 'Не удалось войти.');
            setSubmitting(false);
        }
    };

    return (
        <div className={`adm-root ${styles.page}`}>
            <form className={`adm-card ${styles.card}`} onSubmit={handleSubmit}>
                <h1 className={styles.title}>Электронная библиотека</h1>
                <p className={styles.subtitle}>Панель администратора</p>

                <div className="adm-field">
                    <label className="adm-label" htmlFor="login-email">
                        Электронная почта
                    </label>
                    <input
                        id="login-email"
                        className="adm-input"
                        type="email"
                        autoComplete="username"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        autoFocus
                    />
                </div>

                <div className="adm-field">
                    <label className="adm-label" htmlFor="login-password">
                        Пароль
                    </label>
                    <input
                        id="login-password"
                        className="adm-input"
                        type="password"
                        autoComplete="current-password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>

                {error && <div className={styles.error}>{error}</div>}

                <button
                    type="submit"
                    className={`adm-btn adm-btn-primary ${styles.submit}`}
                    disabled={submitting || !email || !password}
                >
                    {submitting && <span className="adm-spinner" />}
                    {submitting ? 'Проверяем…' : 'Войти'}
                </button>
            </form>
        </div>
    );
};

export default Login;
